var Codec = require('io/codec');
var TopicIdSerialiser = require('./topic-id-serialiser');
var TopicDetailsSerialiser = require('./topic-details-serialiser');

var serialiser = {
    read : function(input) {
        return {
            id : TopicIdSerialiser.read(input),
            path : Codec.readString(input),
            details : TopicDetailsSerialiser.read(input)
        };
    },
    write : function(out, info) {
        TopicIdSerialiser.write(out, info.id);
        Codec.writeString(out, info.path);
        TopicDetailsSerialiser.write(out, info.details);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/topics/details/topic-info-serialiser.js
// module id = 1721
// module chunks = 1